export class GeoObjectTbmSensor {

    constructor(objectTbm, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.objectTbm = objectTbm ?? null;
        this.levelAboveTbmAxis = data.levelAboveTbmAxis ?? null;
        this.notes = data.notes ?? null;

    }

}
